import React, { FC } from "react"
import { RouteComponentProps } from "@reach/router"
import _ from "lodash"
import toggles from 'feature-toggles'
import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"

interface Route {
  hard?: boolean,
  name: string,
  link: string
}

const Recoveries: FC<RouteComponentProps> = (props) => {
  let recoveryPoolsRoute      = toggles.displayNewTenantMarket() ? {name: 'Recovery Pools', link: "/n/recoveries/recovery-pools"} : {name: 'Recovery Pools', link: "/recoveries/recovery-pools"}
  let areaMeasureRoute        = toggles.displayNewTenantMarket() ? {name: 'Area Measures', link: "/n/recoveries/area-measure"} : {name: 'Area Measures', link: "/recoveries/area-measure"}
  let namedRecoveriesRoute    = toggles.displayNewNamedRecoveries() ? {name: 'Named Recoveries', link: "/n/recoveries/named-recoveries"} : {name: 'Named Recoveries', link: "/recoveries/named-recoveries", hard: true}
  let recoveryGroupRoute      = toggles.displayNewTenantMarket() ? {name: 'Recovery Groups', link: "/n/recoveries/recovery-groups"} : {name: 'Recovery Groups', link: "/recoveries/recovery-groups", hard: true}
  let tenantContributionRoute = toggles.displayNewTenantMarket() ? {name: 'Tenant Contributions', link: "/n/recoveries/tenant-contributions"} : {name: 'Tenant Contributions', link: "/recoveries/tenant-contributions", hard: true}
  let tenantGroupRoute        = toggles.displayNewTenantMarket() ? {name: 'Tenant Groups', link: "/n/recoveries/tenant-groups"} : {name: 'Tenant Groups', link: "/recoveries/tenant-groups", hard: true}
  let reportTagRoute          = toggles.displayNewTenantMarket() ? {name: 'Report Tags', link: "/n/recoveries/report-tags"} : {name: 'Report Tags', link: "/recoveries/report-tags", hard: true}

  let tabs: Route[] = [
    recoveryPoolsRoute,
    areaMeasureRoute,
    namedRecoveriesRoute,
    recoveryGroupRoute,
    tenantContributionRoute,
    tenantGroupRoute,
    reportTagRoute
  ]

  return (
    <Container_s>
      <Subnav section="RECOVERIES" tabs={tabs}/>
      <Content_s>
        {props.children}
      </Content_s>
    </Container_s>
  )
}

export default Recoveries
